const parseMdxRawBody = mdxRawBody => {
  const answerMdx = mdxRawBody.split('---')[2]

  return answerMdx.replace(/\n/g, '')
}

export const generateGoogleRichResults = mdxContent => {
  const mainEntity = mdxContent.map(edge => {
    return {
      '@type': 'Question',
      name: edge.node.frontmatter.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: parseMdxRawBody(edge.node.rawBody)
      }
    }
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity
  }
}
